import Stack from '@mui/material/Stack';
import { PROPS } from './TableResult.utils';
import styles from './TableResult.styles';

export default function TableResult({ children }: PROPS) {
  return (
    <Stack sx={styles.wrapper} alignItems="center">
      {children}
    </Stack>
  );
}
